exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-1f7cca4a]{line-height:1.7}.w-50[data-v-1f7cca4a]{display:inline-block;width:50%}@media screen and (max-width: 768px){.w-50[data-v-1f7cca4a]{width:100%;border:none !important}}.bg-gray[data-v-1f7cca4a]{background:rgba(0,0,0,0.05)}.mb-3[data-v-1f7cca4a]{margin-bottom:12px}.px-4[data-v-1f7cca4a]{padding-right:16px;padding-left:16px}.border[data-v-1f7cca4a]{border:1px solid rgba(0,0,0,0.02)}\n", ""]);

// exports
